const Modal = ({ isOpen, 
  onClose, 
  title, 
  content, 
  onAction, 
  actionLabel, 
  closeLabel, 
  children, 
  disabledConfirmBtn, 
  confirmLoading, 
  disableCloseBtn, 
  hideCloseButton,
  hideActionButton,
  icona, // Aggiunta la prop 'icone'
  iconaClass, // Prop per la classe dell'icona
  iconaColorClass,
  modalClassCustom,
  customButton 
}) => {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleAction = () => {
    if (onAction) {
      onAction();
    }
  };

  if (!isOpen) return null;

  return (
    <div className={"rtds-dialog " + (modalClassCustom ?? '')}>
      <div className="rtds-dialog-backdrop active">
        <div
          role="dialog"
          aria-labelledby="dialog1Label"
          aria-modal="true"
          className="rtds-visible"
        >
          <h2
            id="dialog1Label"
            className="rtds-dialog__title rtds-heading-4 rtds-font-bold"
          >
            {icona === true &&
            <svg className={`rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 md:rtds-w-8 md:rtds-h-8 rtds-dialog__left-icon ${iconaColorClass || ''}`} aria-hidden="true" focusable="false" role="img">
                    <use  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${iconaClass || 'outline--information-circle'}`} />
            </svg>
          }
            {title || "Titolo modale"}
          </h2>

          <hr />

          <div className="rtds-dialog__content " style={{whiteSpace:'pre-wrap'}}>{content || ""}</div>

          {/* <div className='rtds-dialog__content' dangerouslySetInnerHTML={{__html: innerContent}}></div> */}
          {children}

          <hr />

          <div className="rtds-dialog__actions rtds-pt-2 rtds-flex rtds-gap-2">
            <button
              disabled={disableCloseBtn}
              type='button'
              className='rtds-btn rtds-btn--icon-right rtds-group/button rtds-btn--outline'
              onClick={handleClose}
              hidden={hideCloseButton || false}
            >
              {closeLabel || "Chiudi"}
              <svg
                className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                aria-hidden="true"
                focusable="false"
                role="img"
              >
                <use
                  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--x-mark`}
                />
              </svg>
            </button>

            <button
              disabled={disabledConfirmBtn}
              type="button"
              className="rtds-btn rtds-btn--icon-right rtds-group/button rtds-btn--primary"
              onClick={handleAction}
              hidden={hideActionButton}
            >
              <span>{actionLabel || ""}</span>
              <span className="rtds-sr-only">
                di {title || "Titolo modale"}
              </span>
              {!confirmLoading && (
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                  />
                </svg>
              )}
              {confirmLoading && (
                <>
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 rtds-animate-spin"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                    />
                  </svg>

                  <span className="rtds-sr-only">Importazione...</span>
                </>
              )}
            </button>

            {customButton && customButton}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
